import { render, staticRenderFns } from "./ContentEdit.vue?vue&type=template&id=24fc7524&scoped=true"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc7524",
  null
  
)

export default component.exports